import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const IMAGES = [
  "/images/retrouvailles/gathering.jpg",
  "/images/retrouvailles/plats.jpg",
  "/images/retrouvailles/corner.jpg",
];

const Manifesto = () => {
  const { t } = useLang();

  return (
    <section id="histoire" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32" data-testid="manifesto-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16"
      >
        <p className="mb-3 font-mono2 text-xs uppercase tracking-[0.3em] text-[#A9761F]">{t.manifesto.overline}</p>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-[#C25E18] sm:text-4xl lg:text-5xl" data-testid="manifesto-title">
          {t.manifesto.title}
        </h2>
      </motion.div>

      <div className="space-y-24 lg:space-y-32">
        {t.manifesto.chapters.map((ch, i) => (
          <motion.div
            key={ch.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className={`grid items-center gap-10 lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            data-testid={`manifesto-chapter-${ch.n}`}
          >
            <div className="relative">
              <span className="font-display absolute -top-10 -left-2 select-none text-8xl font-bold text-[#E07A2B]/15 lg:text-9xl">{ch.n}</span>
              <h3 className="font-display relative text-2xl font-semibold text-[#C25E18] sm:text-3xl">{ch.title}</h3>
              <div className="mt-4 h-px w-16 bg-[#E07A2B]" />
              <p className="mt-6 max-w-lg text-base leading-relaxed text-[#7A6753] sm:text-lg">{ch.text}</p>
            </div>
            <motion.div
              initial={{ clipPath: "inset(8% 8% 8% 8%)", opacity: 0.6 }}
              whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div className="absolute -inset-3 rounded-2xl border border-[#A9761F]/25" />
              <img src={IMAGES[i]} alt={ch.title} loading="lazy"
                className="aspect-[4/3] w-full rounded-xl object-cover shadow-[0_24px_60px_rgba(93,64,36,0.18)]" />
            </motion.div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Manifesto;
